import { faEnvelope, faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import constants from "../constants/constants";
import { useEffect, useState } from "react";
import SEO, { pageSEO } from "../components/seo.component";

export default function Contact() {
  const [popup, setPopup] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    "Email Address": "",
    Message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  async function submitForm(event) {
    event.preventDefault();

    const data = {
      ...formData,
      access_key: constants.EMAIL_ACCESS_KEY,
      subject: "New Contact Form Message",
    };

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
      });

      const response = await res.json();

      if (response?.success) {
        console.log("Success", response);
        setPopup({
          subject: "Thanks for your message!",
          message: "We will get back to you as soon as possible",
        });
        // Clear form after successful submission
        setFormData({
          Name: "",
          "Email Address": "",
          Message: "",
        });
      } else {
        setPopup({
          subject: "We encountered an error in sending this message",
          message: "Please try again later",
        });
      }
    } catch (err) {
      console.log(err);
      setPopup({
        subject: "We encountered an error in sending this message",
        message: "Please try again later",
      });
    }
  }

  const [windowSize, setWindowSize] = useState(window.innerWidth);

  const onWindowResize = () => {
    setWindowSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  const seoConfig = pageSEO.contact();
  return (
    <>
      <SEO {...seoConfig} />
      <div className="w-full bg-white pt-[180px] flex flex-wrap gap-x-16 gap-y-10 justify-center py-32 px-7 min-h-[73vh]">
        <div className="">
          <h4 className="font-semibold text-black text-xl min-w-[20vw]">
            Questions? I'm Here To Help
          </h4>
          <form onSubmit={submitForm} className="mt-6 flex flex-col">
            <div className="form-item">
              <label className="form-label">Name*</label>
              <input
                className="form-input"
                name="Name"
                placeholder="Full Name"
                value={formData.Name}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-item">
              <label className="form-label">Email*</label>
              <input
                className="form-input"
                name="Email Address"
                placeholder="Email Address"
                value={formData["Email Address"]}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-item">
              <label className="form-label">Message*</label>
              <textarea
                className="form-input resize-none h-32"
                name="Message"
                placeholder="Your Message"
                value={formData.Message}
                onChange={handleInputChange}
                required
              />
            </div>
            <button type="submit" className="btn-secondary self-start px-10">
              Send
            </button>
          </form>
        </div>
        <div>
          {/* {constants.MAP && (
            <iframe
              src={constants.MAP}
              height="365"
              width={`${windowSize > 900 ? "500" : "300"}`}
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          )} */}
          <div className="flex flex-col gap-y-2 text-black mt-6">
            <h2 className="text-black text-2xl md:text-4xl libre font-light">
              {constants.AGENT_NAME}, {constants.AGENT_DESIGNATION}
            </h2>
            <p className="italic text-lg font-light tracking-wide">{constants.AGENT_TITLE}</p>
            <p className="text-lg tracking-wide font-light">
              <FontAwesomeIcon
                icon={faPhone}
                className="text-logo-second fa-lg mr-2"
              />{" "}
              {constants.AGENT_NUMBER}{" "}
            </p>
            <p className="text-lg tracking-wide font-light">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="text-logo-second fa-lg mr-2"
              />{" "}
              {constants.AGENT_EMAIL}{" "}
            </p>
            {constants.LOCATION && (
              <p className="text-lg tracking-wide font-light">
                <FontAwesomeIcon
                  icon={faLocationDot}
                  className="text-logo-second fa-lg mr-2"
                />{" "}
                {constants.LOCATION}{" "}
              </p>
            )}
            {constants.BROKERAGE_LOGO && (
              <img src={constants.BROKERAGE_LOGO} className="w-24 my-5" />
            )}
          </div>
        </div>
      </div>
      {popup && (
        <>
          <div className="backdrop" />
          <div className="popup">
            <h5 className="font-bold text-black text-lg">{popup.subject}</h5>
            <p className="font-semibold text-med-grey tracking-wide mb-3">
              {popup.message}
            </p>
            <button onClick={() => setPopup(false)} className="btn-secondary">
              Close
            </button>
          </div>
        </>
      )}
    </>
  );
}
